/**
 * The JSON wire format of uint64.
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 * e.g. "1", "10"
 * JSON value will be a decimal string. Either numbers or strings are accepted.
 */
export type uint64 = string & { uint64Brand: 'brand' } | { uint64Brand: 'brand' };

export namespace uint64 {
  export const nil = '' as uint64
  export const zero = '0' as uint64

  // TODO: tighten this up to specify max digits?
  const reFmt = /^\d+$/

  // Convert an integral number into a uint64. (any fraction is truncated).
  export function fromNumber(val: number): uint64 {
    if (val == 0) {
      return '0' as uint64
    }
    if (!val) {
      return '' as uint64
    }
    if (val < 0) {
      return '' as uint64
    }
    if (val > 18446744073709550000) {
      return '18446744073709551615' as uint64
    }
    val = Math.trunc(val)
    return val.toString() as uint64
  }

  // Parse a uint64 string into an integral number. The returned value may lose precision,
  // since a float cannot precisely hold the entire range of uint64. Returns NaN if the
  // input cannot be parsed.
  export function toNumber(val: uint64 | null | undefined): number {
    if (!val) {
      return 0
    }
    // Must accept numeric literals in the wire format.
    if (typeof val as any === 'number') {
      val = fromNumber(val as any as number)
    }
    let v = val as string
    if (!v.match(reFmt)) {
      return NaN
    }
    return parseInt(v, 10)
  }
}
